<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6"> 
				<el-cascader style="width: 100%;" v-model="searchInfo.orgs" :options="allOrgTree" :props="orgtreePro"  clearable></el-cascader>
			</el-col>
			<el-col :span="6">
				<el-input clearable placeholder="按用户名称查询" v-model="searchInfo.name">
					<template slot="prepend">用户名称</template>
				</el-input>
			</el-col>
			<el-col :span="12"> 
				<div style="min-width: 300px;">
					<el-button type="primary" @click="searchSysUser" icon="el-icon-search">搜索</el-button>
					<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
					<!-- <el-button type="primary" icon="el-icon-plus" @click="addUser">新增</el-button> -->
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="sysUserList"  style="width: 100%"  max-height="700">
			    <el-table-column fixed="left" prop="username" label="系统账号" width="150" align="center"></el-table-column>
				<el-table-column prop="realname" label="用户姓名" width="120" align="center"></el-table-column>
			    <el-table-column prop="telphone" label="联系电话"  width="150" align="center"></el-table-column>
				<el-table-column prop="orgname" label="所属组织" align="center"></el-table-column>
				<el-table-column prop="expirationdates" label="过期时间" width="190" align="center"></el-table-column>
				<el-table-column prop="state" label="状态" width="90" align="center">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.state == 'normal'" style="margin-left: 10px;margin-right: 10px;">正常</el-tag>
						<el-tag v-else style="margin-left: 10px;margin-right: 10px;" type="danger">停用</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="登录方式" width="200" align="center">
					<template slot-scope="scope">
						<div style="display: inline-block;">
							<el-tag v-if="scope.row.type.indexOf('wechat') > -1 " style="margin-left: 5px;margin-right: 5px;" type="success">小程序</el-tag>
							<el-tag v-if="scope.row.type.indexOf('web') > -1 " style="margin-left: 5px;margin-right: 5px;" type="info">网页端</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="150" align="center">
					<template slot-scope="scope">
						<a @click="goSysUserDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a @click="noUseDetail(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="userTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="true" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<UserDetail @needRefrash="needRefrash" :add="isadd" :allOrgTree="allOrgTree" :selecteduser="selectset"></UserDetail>
		</el-dialog>
	</div>
</template>

<script>
	//import dayjs from 'dayjs'
	import { querySysUserByPage, queryAllOrgTree, deleteSysUser } from '/static/apiUrl.js'
	import UserDetail from './userdetail'
	export default {
		name : 'SysUser',
		data() {
			return {
				detailShow: false,
				editok : false,
				isadd : false,
				detailTitle: '用户详情',
				selectset: null,	
				searchInfo:{
					name: '',
					orgs : '',
				},
				allOrgTree : [],
				param : {
					page : 1,
					pagenum : 10,
				},
				userTotal : 0,
				sysUserList : [],
				orgtreePro : {
					checkStrictly: true,
					value : "id",
					label : "name",
					children : "children"
				}
			}
		},
		mounted() {
			this.initData()
			this.queryUserList()
		},
		components: {
			UserDetail,
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryUserList()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryUserList()
			},
			initData() {
				this.allOrgTree = []
				queryAllOrgTree().then(res => {
					if(0 == res.code){
						this.allOrgTree = res.datas
					}
				})
			},
			searchSysUser(){
				this.param.page = 1
				this.sysUserList = []
				this.queryUserList()
			},
			clearSearch(){
				this.searchInfo.name = ''
				this.searchInfo.orgs = ''
				this.param.page = 1
				this.queryUserList()
			},
			queryUserList(){
				this.sysUserList = []
				let orgid = ""
				if(this.searchInfo.orgs.length > 0){
					orgid = this.searchInfo.orgs[this.searchInfo.orgs.length -1]
				}
				querySysUserByPage({
					org : orgid,
					name : this.searchInfo.name,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					//console.log(res)
					if(0 == res.code){
						this.userTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							this.sysUserList.push(set)
						})
					}
				})
			},
			goSysUserDetail(idx,row){
				this.detailTitle = '用户详情'
				this.isadd = false
				console.log(idx,row)
				this.selectset = JSON.parse(JSON.stringify(this.sysUserList[idx]))
				this.detailShow = true
			},
			noUseDetail(idx,row){
				this.$confirm('此操作将删除用户 '+this.sysUserList[idx].name+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteSysUser({
						id : this.sysUserList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryUserList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addUser(){
				this.detailTitle = "新增用户"
				this.isadd = true
				this.selectset = null
				this.detailShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				console.log('ddd')
				if(this.editok){
					this.queryUserList()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>